import { render, staticRenderFns } from "./VpnWarningBanner.vue?vue&type=template&id=f1031cf6"
import script from "./VpnWarningBanner.vue?vue&type=script&lang=js"
export * from "./VpnWarningBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports